import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router';

import { useCoefficientsConfig } from './configuration';

export const useSeasonYear = () => {
  const {
    configuration: { endSeason, enableCalendar, currentSeason },
  } = useCoefficientsConfig();

  const [searchParams, setSearchParams] = useSearchParams();
  const seasonYear = searchParams.get('year');

  const setSeasonYear = useCallback(
    (year: number) => {
      setSearchParams({ year: year.toString() });
    },
    [setSearchParams],
  );

  useEffect(() => {
    enableCalendar && !seasonYear && setSeasonYear(currentSeason);
  }, [endSeason, enableCalendar, seasonYear, setSeasonYear, currentSeason]);

  return { seasonYear, setSeasonYear };
};
